export default __webpack_public_path__ + "static/media/icon-up-and-down.21a6b14e.svg";